module.exports = __webpack_public_path__ + "5ed865e09b3ae13ee3b2b2b1e73113a0.fbx";